import type { PublicSlotKey } from '#packages/apilib';
import type { AiPublicApi } from './api';

export const AiApiKey: PublicSlotKey<AiPublicApi> = {
  name: 'AiApi',
  public: true,
};
